import routes from './module/routes';
import store from './module/store';

export default {
  name: 'login-extended',
  routes,
  store,
  requires: ['api', 'auth', 'servicePlan']
};
